import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PagDoubleChevronLeft = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5308 21.0129C21.2425 21.3011 20.8516 21.463 20.4441 21.463C20.0365 21.463 19.6456 21.3011 19.3574 21.0129L11.6722 13.3278C11.3841 13.0395 11.2222 12.6487 11.2222 12.2411C11.2222 11.8335 11.3841 11.4426 11.6722 11.1544L19.3574 3.46924C19.4992 3.32244 19.6688 3.20534 19.8563 3.12479C20.0438 3.04423 20.2455 3.00183 20.4496 3.00006C20.6537 2.99828 20.8561 3.03717 21.045 3.11446C21.2339 3.19174 21.4055 3.30587 21.5498 3.45019C21.6941 3.5945 21.8083 3.76612 21.8855 3.95501C21.9628 4.14391 22.0017 4.3463 21.9999 4.55039C21.9982 4.75448 21.9558 4.95617 21.8752 5.14369C21.7947 5.33121 21.6776 5.50082 21.5308 5.6426L14.9323 12.2411L21.5308 18.8396C21.8189 19.1278 21.9808 19.5187 21.9808 19.9263C21.9808 20.3338 21.8189 20.7247 21.5308 21.0129ZM12.3086 21.0129C12.0203 21.3011 11.6294 21.463 11.2219 21.463C10.8143 21.463 10.4234 21.3011 10.1352 21.0129L2.45002 13.3278C2.16187 13.0395 2 12.6487 2 12.2411C2 11.8335 2.16187 11.4426 2.45002 11.1544L10.1352 3.46924C10.4251 3.18926 10.8133 3.03433 11.2163 3.03783C11.6193 3.04133 12.0049 3.20298 12.2898 3.48796C12.5748 3.77294 12.7365 4.15845 12.74 4.56145C12.7435 4.96446 12.5885 5.35272 12.3086 5.6426L5.71007 12.2411L12.3086 18.8396C12.5967 19.1278 12.7586 19.5187 12.7586 19.9263C12.7586 20.3338 12.5967 20.7247 12.3086 21.0129Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PagDoubleChevronLeft.displayName = 'PagDoubleChevronLeft';
